<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link to="/mypage/reviews/received">投稿された感想</router-link></li>
                <li class="breadcrumb-item">ミュート一覧</li>
            </ol>
        </nav>
        <div class="container">
            <div class="sticky">
                <page :last_page="mutes.last_page" v-model="page" @goto="goto"></page>
            </div>
            <div v-if="mutes.total">
                <div class="card" v-for="m in mutes.data" :key="m.id">
                    <div class="card-body">
                        <ruby>{{m.name}}<rt>{{m.kana}}</rt></ruby>
                        <button type="button" class="close" aria-label="Close" @click="detach(m)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </div>
            <div v-else class="nothing">ミュートしている人はいません。</div>
        </div>
    </div>
</template>

<script>
import page from"components/Page";
export default {
    components: {
        page
    },
    data() {
        return {
            mutes: {},
            page: 1,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            setTimeout(() => {this.load()});
        },
        load() {
            axios.get("/mypage/mutes/get", {params: {page: this.page}}).then(res => {
                this.mutes = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        detach(m) {
            Swal.fire({
                title: "ミュート解除",
                html: `${m.name}さんのミュートを解除します。<br>よろしいですか？`,
                icon: "success",
                showCancelButton: true,
                confirmButtonText: "ミュート解除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "forestgreen",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/unmute", {'id': m.user_id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => { alert.err(err.response); });
                }
            });
        }
    },
    mounted() {
        this.load();
    }
}
</script>